export enum SizeVariantType {
    Large = 'large',
    Standard = 'standard',
    Medium = 'medium',
    Small = 'small',
    XSmall = 'xsmall',
}
